module.exports = __webpack_public_path__ + "static/img/discussion-empty.15da86c9.png";